import { AlphaPBoxOutlineIcon } from './AlphaPBoxOutlineIcon';

/**
 * author: Contributors
 * id B9B61AA9-C657-4C73-8C75-2A01C08672A6
 * name alpha-p-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-p-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterPBoxOutlineIcon = AlphaPBoxOutlineIcon;
export default LetterPBoxOutlineIcon